import React, { useContext } from "react";
import { View, Image } from "react-native";
import AppContext from "../context";

export default function Puzzle({ l, size }) {
  const { resolveURL } = useContext(AppContext);

  return (
    <View style={{ width: size, height: size }}>
      {l ? (
        <Image
          source={{
            uri: resolveURL("game", l, 300),
          }}
          style={{ width: size, height: size }}
        />
      ) : (
        <View
          style={{
            backgroundColor: "#F2F2F2",
            width: size,
            height: size,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={require("../assets/question-mark.png")}
            style={{ width: 30, height: 50 }}
          />
        </View>
      )}
    </View>
  );
}
